import { FichaCadastroTipo } from './../../ficha-cadastro-tipo';
import { FichaCadastro } from './../../ficha-cadastro';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { cloneDeep } from 'lodash';
import { Veiculo } from '../../model/veiculo';

@Component({
  selector: 'app-ficha-cadastro-veiculo-lista',
  templateUrl: './ficha-cadastro-veiculo-lista.component.html',
  styleUrls: ['./ficha-cadastro-veiculo-lista.component.scss'],
})
export class FichaCadastroVeiculoListaComponent {
  @Input() veiculos: Veiculo[];
  @Input() isPesados?: boolean;
  @Output() changeForm: EventEmitter<any> = new EventEmitter();
  @Output() changeFormValid: EventEmitter<any> = new EventEmitter();
  @Input() hasIdSimulacao: boolean;
  @Input() fichaCadastro: FichaCadastro;

  public fichaCadastroTipo = FichaCadastroTipo;

  savedVeiculo: Veiculo;
  isInformarManualmente: boolean;

  constructor() { }

  public addVeiculo(): void {
    this.isInformarManualmente = false;
    this.veiculos.push({});
  }

  public saveVeiculo(veiculo: Veiculo, index: number): void {
    this.veiculos[index] = { ...this.veiculos[index], ...veiculo, saved: true, isEdit: false, pendencia: null };
  }

  public removeVeiculo(index: number): void {
    this.veiculos.splice(index, 1);
    if (!this.veiculos.length) {
      this.addVeiculo();
    }
  }

  public cancelVeiculo(index: number): void {
    if (this.veiculos[index].isEdit) {
      this.veiculos[index] = { ...this.savedVeiculo, isEdit: false };
      return;
    }
    this.removeVeiculo(index);
  }

  public editarVeiculo(isInformarManualmente, index: number): void {
    this.isInformarManualmente = isInformarManualmente;
    this.veiculos[index].isEdit = true;
    this.savedVeiculo = cloneDeep(this.veiculos[index]);
  }

  public get showAddVeiculo(): boolean {
    if (this.fichaCadastro._tipo && this.fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND === this.fichaCadastro._tipo) {
      return false;
    }
    return this.veiculos.length < 3 && this.veiculos.every((v) => v.saved);
  }
}
